var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgManagementOrganisationen = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "model2-icon",
    viewBox: "0 0 181.46 181.46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".model2-icon .cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.73,181.46a90.73,90.73,0,1,1,90.73-90.73A90.83,90.83,0,0,1,90.73,181.46ZM90.73,3a87.73,87.73,0,1,0,87.73,87.73A87.84,87.84,0,0,0,90.73,3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.75,
    cy: 42.29,
    r: 17.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 131.99,
    cy: 115.16,
    r: 17.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 49.51,
    cy: 115.16,
    r: 17.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.75,
    cy: 90.73,
    r: 17.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.75,167.63a76.9,76.9,0,1,1,76.9-76.9A77,77,0,0,1,90.75,167.63Zm0-150.8a73.9,73.9,0,1,0,73.9,73.9A74,74,0,0,0,90.75,16.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "113.3 79.34 113.3 79.33 116.3 79.33 113.3 79.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.63 72.06 101.87 71.85 102.62 70.57 102.62 69.06 103.39 69.27 102.63 70.55 102.63 72.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.59,134.25c-9.15,0-16.08-3.07-19.65-8.75-3.86-6.15-3.26-14.5,1.68-23.52,4.8-8.74,13.16-17.15,23.54-23.67,2.08-1.31,4.23-2.52,6.38-3.62-.09-1.49-.13-3-.13-4.56,0-25.62,11.91-46.46,26.54-46.46s26.54,20.84,26.54,46.46c0,1.57,0,3.17-.14,4.77,2,1,4,2.18,6,3.41,10.38,6.52,18.74,14.93,23.54,23.67,5,9,5.55,17.37,1.69,23.52-7.79,12.39-31.77,11.39-53.47-2.24-1.49-.94-2.95-1.92-4.35-2.93-1.4,1-2.86,2-4.35,2.93C76,129.79,64.81,133.67,54.86,134.19,54.09,134.23,53.33,134.25,52.59,134.25Zm41-15.59c1,.7,2.06,1.4,3.12,2.06C117,133.47,139.12,134.89,146,123.9c3.25-5.18,2.62-12.45-1.78-20.48-4.56-8.3-12.55-16.31-22.51-22.57-1.47-.92-3-1.8-4.49-2.62C116.62,97,108.67,110.55,93.58,118.66ZM64.63,78c-1.64.88-3.27,1.83-4.87,2.83-10,6.26-17.95,14.27-22.51,22.57-4.4,8-5,15.3-1.77,20.48s10.08,7.77,19.22,7.3c9.45-.5,20.14-4.22,30.1-10.48,1.07-.67,2.12-1.36,3.14-2.07C73.08,110.53,65.25,96.87,64.63,78Zm3-1.5c.24,18.8,7.85,32.23,22.62,39.94l.54.28.5-.25c15-7.71,22.78-21.08,23-39.78a68.65,68.65,0,0,0-11.7-4.46h-.14l-.19-.09a49.65,49.65,0,0,0-11.5-1.81A50,50,0,0,0,79.1,72.2h0A68.37,68.37,0,0,0,67.6,76.52Zm35.72-7.18a70.31,70.31,0,0,1,11.1,4.12c0-1.12.07-2.23.07-3.33,0-24-10.56-43.46-23.54-43.46S67.41,46.16,67.41,70.13c0,1.05,0,2.11.06,3.14a72.07,72.07,0,0,1,10.83-4,53.55,53.55,0,0,1,12.08-1.94l.37-.19.4.19A53.52,53.52,0,0,1,103,69.24h.15Zm-12.58-.42-.64,1.27Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgManagementOrganisationen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/management-organisationen.e4a2f0a8.svg";
export { ForwardRef as ReactComponent };